import { useState } from 'react';

import useTranslation from '@/utils/hooks/translation/useTranslation';
import useAcl from '@/utils/hooks/user/useAcl';

//hooks
import { useLabelsAlbumsOnMediaViewer } from '@/hooks/utils/useLabelsAlbumsOnMediaViewer';

import PropTypes from 'prop-types';

// Lib
import { aclFeatures } from '@/lib/acl/aclFeatures';
import { POST, STORY } from '@/lib/posts/postTypes';
import { X } from '@/lib/socialProfile';

//components
import Icon from '@/components/base/Icon';
import { AlbumsSection } from '@/components/composite/MediaViewer/components/LabelsAlbums/AlbumsSection';
import { LabelsSection } from '@/components/composite/MediaViewer/components/LabelsAlbums/LabelsSection';
import { TooltipPlanRestriction } from '@/components/layouts/LayoutPlatform/components/Menu/components/TooltipPlanRestriction';

export const MediaViewerLabelsAlbums = ({
    socialProfile,
    post,
    postType = POST,
    isLoading,
    mutateMedia,
    mutateMedias
}) => {
    const { hasAcl } = useAcl();
    const isLocked = !hasAcl(aclFeatures.content.campaign.read);
    const { t } = useTranslation('commons');
    const [isOpenLabels, setIsOpenLabels] = useState(false);
    const [isOpenAlbums, setIsOpenAlbums] = useState(false);

    const { handleLabelsEvent, handleAlbumsEvent } = useLabelsAlbumsOnMediaViewer({
        mutateMedias,
        mutateMedia,
        type: postType === STORY ? postType : 'media'
    });

    if (isLoading) return null;
    return (
        <div
            className="mt-10 flex flex-col space-y-6"
            data-testid="media-viewer-album-label-section">
            <p className="flex items-center space-x-3">
                <Icon
                    icon="albums-labels"
                    className="text-xl text-icoGray-500 dark:text-icoDarkMode-wolf"
                />
                <span className="text-base dark:text-white">{t('media_viewer.albums_labels')}</span>
                {isLocked && (
                    <TooltipPlanRestriction>
                        <Icon icon="crown" className="text-icoBlue" />
                    </TooltipPlanRestriction>
                )}
            </p>
            <div className="flex flex-col space-y-3">
                {/* Hide Albums/Campaign section for X platform */}
                {socialProfile?.social_network_type !== X && (
                    <div className="-ml-2 flex flex-wrap">
                        <AlbumsSection
                            socialProfile={socialProfile}
                            post={post}
                            postType={postType}
                            handleAlbumsEvent={handleAlbumsEvent}
                            isOpenAlbums={isOpenAlbums}
                            toggle={setIsOpenAlbums}
                            disabled={isLocked}
                        />
                    </div>
                )}
                <div className="-ml-2 flex flex-wrap">
                    <LabelsSection
                        socialProfile={socialProfile}
                        post={post}
                        postType={postType}
                        handleLabelsEvent={handleLabelsEvent}
                        isOpenLabels={isOpenLabels}
                        toggle={setIsOpenLabels}
                        disabled={isLocked}
                    />
                </div>
            </div>
        </div>
    );
};

MediaViewerLabelsAlbums.propTypes = {
    socialProfile: PropTypes.object,
    post: PropTypes.object,
    postType: PropTypes.string,
    isLoading: PropTypes.bool,
    mutateMedia: PropTypes.func,
    mutateMedias: PropTypes.func
};
